const ANNOUNCEMENT_LINK_REGEX =
	/\{((?:video_id|resource_id|document_id):\s'\d+'),\s(display:\s'.[^}]*')\}/gimu;

const ANNOUNCEMENT_PATHS: Record<string, string> = {
	video_id: "/videos",
	document_id: "/documents",
	resource_id: "/resources",
};

const escapeHtml = (value: string): string =>
	value
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");

export const replaceAnnouncementTokens = (description: string): string => {
	let linkIndex = 0;

	return description.replace(
		ANNOUNCEMENT_LINK_REGEX,
		(_match, typeAndId: string, displayValue: string) => {
			const type = typeAndId.split(":")[0].trim();
			const href = ANNOUNCEMENT_PATHS[type];
			const title = displayValue
				.replace(/^display:\s*'/i, "")
				.replace(/'$/, "");
			const id = linkIndex === 1 ? ' id="linked-document"' : "";
			linkIndex += 1;

			return `<a class="linkified" href="${href}" target="_self"${id}>${escapeHtml(
				title,
			)}</a>`;
		},
	);
};
